export const downloadsApps = [
  {
    name: 'Приложение курьера',
    icon: 'mdi-moped-outline',
    platform: 'iOS · Android',
    platformIcon: 'mdi-cellphone',
    stores: [
      {
        label: 'App Store',
        icon: 'mdi-apple',
        url: 'https://apps.apple.com/ru/app/id6737026182',
      },
      {
        label: 'Google Play',
        icon: 'mdi-google-play',
        url: 'https://play.google.com/store/apps/details?id=ru.sushiset.courier',
      },
      {
        label: 'RuStore',
        icon: 'mdi-storefront-outline',
        url: 'https://www.rustore.ru/catalog/app/ru.sushiset.courier',
      },
    ],
  },
  {
    name: 'Планшет сборки',
    icon: 'mdi-tablet-dashboard',
    platform: 'Android',
    platformIcon: 'mdi-android',
    stores: [
      {
        label: 'Google Play',
        icon: 'mdi-google-play',
        url: 'https://play.google.com/store/apps/details?id=ru.suhiset.place',
      },
      {
        label: 'RuStore',
        icon: 'mdi-storefront-outline',
        url: 'https://www.rustore.ru/catalog/app/ru.suhiset.place',
      },
    ],
  },
]

export const cashModule = {
  name: 'Кассовый модуль',
  extras: [
    {
      title: 'Если CRM запускается с ошибкой',
      note: 'Установите Microsoft Visual C++ Redistributable под разрядность вашей системы.',
      items: [
        {
          label: 'Visual C++ Redistributable x64',
          url: 'https://static.setsushi.ru/downloads/VC_redist.x64.exe',
        },
        {
          label: 'Visual C++ Redistributable x86',
          url: 'https://static.setsushi.ru/downloads/VC_redist.x86.exe',
        },
      ],
    },
    {
      title: 'Если в окне ничего не отображается',
      note: 'Даже после установки Visual C++ Redistributable — установите WebView2 Runtime: на сайте Microsoft выберите Evergreen Standalone Installer под разрядность вашей системы.',
      items: [
        {
          label: 'WebView2 Runtime на сайте Microsoft',
          url: 'https://developer.microsoft.com/en-us/microsoft-edge/webview2/#download',
          external: true,
        },
      ],
    },
  ],
}

export const hardwareSpec = {
  title: 'Требования к оборудованию',
  lead: 'Что купить и подготовить в филиале до подключения к F.A.K.T.',
  source: {
    text: 'Списки касс и терминалов - по данным',
    label: 'kkmserver.ru',
    url: 'https://kkmserver.ru/KkmServer#Device',
  },
  workplaces: [
    {
      key: 'cash',
      title: 'Кассовое место филиала',
      icon: 'mdi-cash-register',
      tone: 'dark',
      wide: true,
      items: [
        {
          name: 'Компьютер',
          requirement: 'Windows 10 (64-бит, сборка 1809 и новее) или Windows 11. Минимум: процессор 1 ГГц, ОЗУ 2 ГБ, диск 32 ГБ, монитор 1920×1080 (Full HD) при масштабе Windows 100%.',
          details: [
            'При масштабе 125% CRM переходит в сжатую раскладку: полезной ширины экрана становится меньше 1700 px.',
          ],
          recommended: 'ОЗУ 4 ГБ и SSD',
        },
        {
          name: 'USB-порты',
          requirement: 'Три свободных порта: фискальный регистратор, принтер чеков, платёжный терминал.',
        },
        {
          name: 'Кассовое ПО',
          requirement: 'ККМсервер ставится вместе с кассовым модулем со страницы загрузок. Нужен .NET Framework 4.8.',
        },
        {
          name: 'Фискальный регистратор',
          requirement: 'Онлайн-касса из списка поддерживаемых ККМсервером, зарегистрирована в ОФД.',
          details: [
            'АТОЛ: 1Ф, 11Ф, 15Ф, 20Ф, 22Ф, 22v2Ф, 25Ф, 27Ф, 30Ф, 35Ф, 42ФС, 47ФА, 50Ф, 55Ф, 77Ф, 91Ф, 92Ф, СТ-5Ф, Казначей ФА',
            'ШТРИХ-М: 01Ф, ON-LINE, ЛАЙТ-01Ф, ЛАЙТ-02Ф, М-02-Ф, МИНИ-01Ф, МИНИ-02Ф, ФР-01Ф, ФР-02Ф, ЗНАК-М3',
            'RR-Electro: РР-01Ф, РР-02Ф, РР-03Ф, РР-04Ф',
            'ЭЛВЕС: ЭЛВЕС-ФР-Ф',
            'РИТЕЙЛ: 01Ф, 02Ф, Комбо-01Ф',
            'Dreamkas Viki Print: 57Ф, 57+Ф, 80+Ф',
            'КИТ: Онлайн-Ф, Терминал-ФА',
          ],
          verified: 'АТОЛ 30Ф, Dreamkas Viki Print 57Ф',
        },
        {
          name: 'Принтер чеков',
          requirement: 'Термопринтер на ленту 80 мм, протокол ESC/POS, подключение USB, с драйвером под Windows. Один принтер (админ) или два (админ и кухня) - по схеме филиала.',
          verified: 'SAM4S ELLIX50W',
        },
        {
          name: 'Платёжный терминал',
          requirement: 'Терминал банка для интеграции с кассой (не автономный), подключение USB, драйвер от банка.',
          details: [
            'Протоколы ККМсервера: Сбербанк (СБРФ); INPAS (Verifone, PAX, IRAS); ARCUS-2 (Ingenico); UCS; TTK2.',
          ],
          verified: 'Терминалы Сбербанка, планшетный и классический',
        },
      ],
    },
    {
      key: 'tablet',
      title: 'Планшет сборки',
      icon: 'mdi-tablet',
      tone: 'primary',
      wide: false,
      items: [
        {
          name: 'Планшет',
          requirement: 'Android 7.0 и новее, диагональ от 10 дюймов, разрешение Full HD (1920×1200 или 1920×1080), Wi‑Fi.',
          details: [
            'Google-сервисы не обязательны: приложение есть в RuStore и Google Play.',
          ],
          verified: 'Huawei MatePad SE 11',
        },
        {
          name: 'Питание',
          requirement: 'Постоянное питание от сети в смену: экран не гаснет во время работы.',
        },
      ],
    },
    {
      key: 'courier',
      title: 'Смартфон курьера',
      icon: 'mdi-moped-outline',
      tone: 'primary',
      wide: false,
      items: [
        {
          name: 'Смартфон',
          requirement: 'Android 7.0 и новее или iOS 14 и новее, GPS, мобильный интернет.',
          details: [
            'Приложению нужно разрешение на геолокацию «Всегда»: маршрут отслеживается в фоне.',
          ],
        },
      ],
    },
    {
      key: 'internet',
      title: 'Интернет в филиале',
      icon: 'mdi-wifi',
      tone: 'primary',
      wide: false,
      items: [
        {
          name: 'Основной канал',
          requirement: 'Стабильный интернет-канал.',
        },
        {
          name: 'Резервный канал',
          requirement: '4G-роутер или смартфон в режиме модема на случай сбоя основного канала.',
        },
        {
          name: 'Wi‑Fi',
          requirement: 'Wi‑Fi в зоне сборки для планшета.',
        },
      ],
    },
  ],
}
